import { Button } from "wiz-front-shared/components/button/Button";
import { useAtomValue, useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { resetSignUpData, signUpHistoryDepthAtom, setSignUpExiting } from "store/signUpStore";
import { userStore } from "store/userStore";
import './SignUpStep8.css';

// Step8: 로그인 실패 (중복 제외한 기타 오류)
// 로그인 페이지로 이동하는 버튼 제공
export const SignUpStep8 = () => {
    const { t } = useTranslation();
    const signupState = useAtomValue(userStore.signup.stateAtom);
    const resetSignUp = useSetAtom(resetSignUpData);
    const historyDepth = useAtomValue(signUpHistoryDepthAtom);

    const errorCode = signupState.error?.code;

    const getErrorMessage = () => {
        switch (errorCode){
            case "INVALID_INPUT":
                // 입력값 검증 실패 (이메일 형식, 비밀번호 규칙 등)
                return t("signUp.step8.invalidInput");
            case "BAD_REQUEST":
                // 요청 형식 오류
                return t("signUp.step8.badRequest");
            case "INTERNAL_ERROR":
                // 서버 오류
                return t("signUp.step8.serverError");
            // 가입 연령 정책·법정대리인 동의 (서버 재판정 결과)
            case "MINOR_NOT_ALLOWED":
            case "AGE_BELOW_SERVICE_MIN":
                return t("signUp.step8.ageNotAllowed");
            case "BIRTH_REQUIRED":
                return t("signUp.step8.birthRequired");
            case "INFO_CONFIRM_REQUIRED":
            case "GUARDIAN_INFO_REQUIRED":
                return t("signUp.step8.guardianInfoRequired");
            case "GUARDIAN_CTN_SAME_AS_CHILD":
                return t("signUp.step8.guardianCtnSame");
            case "VERIFICATION_NOT_VERIFIED":
                return t("signUp.step8.verificationRequired");
            default:
                return t("signUp.step8.default");
        }
    };

    const handleGoToLogin = () => {
        // /signin 으로 빠져나가기 — flicker 없이 history pop
        setSignUpExiting(true);
        window.history.go(-(historyDepth + 1));
        setTimeout(() => {
            userStore.signup.onDefault();
            resetSignUp();
        }, 0);
    };

    return (
        <div className="sign-up-step-8" style={{ display: "flex" }}>
            <div className="sign-up-step-8-content">
                <span className="sign-up-step-8-title">{t("signUp.step8.title")}</span>
                <span className="sign-up-step-8-message">{getErrorMessage()}</span>
            </div>
            <div className="sign-up-bottom-btn">
                <Button
                    text={t("signInText")}
                    onPress={handleGoToLogin}
                />
            </div>
        </div>
    );
};
